import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "creationV2__body" }
const _hoisted_2 = { class: "creationV2__scroll-wrapper" }
const _hoisted_3 = { class: "creationV2__container text-center" }
const _hoisted_4 = { class: "font-bold text-2xl xs:text-3xl lg:text-[3vw] lg:leading-tight text-creation-on-background" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_Transition, {
          appear: "",
          name: "custom-classes",
          "enter-active-class": "animate__fadeInUp",
          "leave-active-class": "animate__fadeOut"
        }, {
          default: _withCtx(() => [
            _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.agentMessage), 1)
          ]),
          _: 1
        })
      ])
    ])
  ]))
}